import { agent } from '../utils/agent'
const API_URL = process.env.REACT_APP_API_URL

// PlayHQ (play.cricket.com.au) import. A scope is { type: 'season' | 'grade' | 'match', id }.
const getLink = async () => {
  const response = await agent.get(`${API_URL}playhq/link`)
  return response.data
}
const saveLink = async (url) => {
  const response = await agent.post(`${API_URL}playhq/link`, { url })
  return response.data
}
const removeLink = async () => {
  const response = await agent.post(`${API_URL}playhq/unlink`)
  return response.data
}
const resolveScope = async (url) => {
  const response = await agent.post(`${API_URL}playhq/scope`, { url })
  return response.data
}

const preview = async (type, data) => {
  const response = await agent.post(`${API_URL}playhq/preview/${type}`, data)
  return response.data
}
const runImport = async (type, data) => {
  const response = await agent.post(`${API_URL}playhq/import/${type}`, data)
  return response.data
}

const PlayHQService = {
  getLink,
  saveLink,
  removeLink,
  resolveScope,
  preview,
  runImport,
}

export default PlayHQService
